export type AppToastTone = 'info' | 'warn' | 'error' | 'success';

export interface AppToastDetail {
  message: string;
  tone: AppToastTone;
  durationMs?: number;
}

const TOAST_EVENT = 'msapling:toast';

const DEFAULT_DURATION: Record<AppToastTone, number> = {
  success: 3000,
  info:    4200,
  warn:    5000,
  error:   6000,
};

export const showToast = (
  message: string,
  tone: AppToastTone = 'info',
  durationMs?: number
): void => {
  const resolvedDuration = durationMs ?? DEFAULT_DURATION[tone];
  if (typeof window === 'undefined') return;
  const text = String(message || '').trim();
  if (!text) return;
  window.dispatchEvent(new CustomEvent<AppToastDetail>(TOAST_EVENT, {
    detail: { message: text, tone, durationMs: resolvedDuration },
  }));
};

export const onToast = (handler: (detail: AppToastDetail) => void): (() => void) => {
  if (typeof window === 'undefined') return () => {};
  const listener = (event: Event) => {
    const customEvent = event as CustomEvent<AppToastDetail>;
    const detail = customEvent?.detail;
    if (!detail?.message) return;
    handler(detail);
  };
  window.addEventListener(TOAST_EVENT, listener as EventListener);
  return () => window.removeEventListener(TOAST_EVENT, listener as EventListener);
};
